import { AnyAction } from 'redux'
import { userAccessModel } from '../../Interfaces'

// Define the initial state

const initialState: userAccessModel = {
  userName: null,
  userFullname: null,
  application: null,
  supportTeam: null,
  access: null,
  accessId: null,
  appId: 0,
  teamId: null,
  team: null
}

// Define action types
const LOGIN = 'LOGIN'
const LOGOUT = 'LOGOUT'

// Define the reducer
const userAccessReducer = (state = initialState, action: AnyAction): userAccessModel => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        userName: action.payload.userName,
        userFullname: action.payload.userFullname,
        application: action.payload.application,
        supportTeam: action.payload.supportTeam,
        access: action.payload.access,
        accessId: action.payload.accessId,
        appId: action.payload.appId,
        teamId: action.payload.teamId,
        team: action.payload.team
      }
    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default userAccessReducer
